export const addCommas = (num: number | undefined) => {
  if (num === undefined) return;
  return String(num || 0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
};
